import React, { useCallback } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import BEMHelper from 'react-bem-helper';
import SVGIcon from '@ringcentral/rcv-ui/src/components/Icon/SVGIcon';
import supportSvg from '@ringcentral/rcv-ui/src/img/icon_help.svg';
import '@ringcentral/rcv-ui/src/common/svg-icons.less';
import { ImageView } from '@ringcentral/rcv-ui/src/components/ImageView';
import { openLinkInNewTab } from '@ringcentral/rwc-utils/src/dom';
import useOrientation from '@ringcentral/rwc-utils/src/hooks/use-orientation';
import { useBrandConfig } from '@low/utils/get-brand-config';
import { getIsRCBrand } from '@ringcentral/rwc-branding/src/utils';

const classes = new BEMHelper('Launcher');

export const LOGO_POSITION_TOP_LEFT = 'top-left';
export const LOGO_POSITION_CENTER = 'center';

export const Logo = props => {
    const getBrandConfig = useBrandConfig();
    const supportRootPage = getBrandConfig(['supportRootPage']);
    const mainLogoUrl = getBrandConfig(['assets', 'mainLogoUrl']);
    const { logoPosition = LOGO_POSITION_TOP_LEFT, extra = getIsRCBrand(), track } = props;
    const { orientation } = useOrientation();

    const openHelpLink = useCallback(() => {
        openLinkInNewTab(supportRootPage);
        if (track) track('Support');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [track]);

    return (
        <div {...classes('mobile', logoPosition, `mobile-orientation-${orientation}`)}>
            <div className='mobile-logo'>
                <ImageView src={mainLogoUrl} />
            </div>
            {extra && (
                <div className='mobile-logo-extra'>
                    <button
                        onClick={openHelpLink}
                        aria-label={i18n.t('menu.HELP')}
                        data-at='HelpMoreItem'>
                        <SVGIcon icon={supportSvg} className='svg-support' />
                    </button>
                </div>
            )}
        </div>
    );
};

Logo.propTypes = {
    logoPosition: PropTypes.string,
    extra: PropTypes.bool,
    track: PropTypes.func,
};
